import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { logError } from '../../apis/calls';
import App from '../../App';
import { useAuthorizationContext } from '../AuthorizationProvider/AuthorizationProvider';
import ErrorFallback from '../ErrorFallback/ErrorFallback';

const AppWithErrorBoundary = () => {
  const { user } = useAuthorizationContext();

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={error => {
        logError(error, user);
      }}
    >
      <App />
    </ErrorBoundary>
  );
};
export default AppWithErrorBoundary;
